import { Dispatch, SetStateAction } from "react";
import { useUser } from "../dataAccess/api/user";
import { useEditor } from "../wysiwyg/EditorCtx";
import type { ManagerJwtResponse } from "../dataAccess/api/managers";
import {
  BrowserTab,
  useNavigateNewTabSync,
  useNavigateSameTabExternal,
} from "./navigation";

export const useNavigateToManagerAppByJwt = (
  setIsManagerJwtLoading: Dispatch<SetStateAction<boolean>>,
) => {
  const navigateSameTabExternal = useNavigateSameTabExternal();
  const navigateNewTab = useNavigateNewTabSync();
  const { manageRetUrl } = useEditor();
  const { user } = useUser();

  async function navigateToManagerAppByJwt(
    jwtRequest: () => Promise<ManagerJwtResponse>,
    path?: string,
    options?: { target?: "_blank"; hash?: string },
  ) {
    const openNew = options?.target === "_blank";
    const tab = new BrowserTab();
    try {
      const authenticated =
        !user?.guestUser &&
        user?.confirmed &&
        user?.organization?.allowedInMarketplace;

      if (!authenticated) {
        const url = process.env.NEXT_PUBLIC_MANAGER_APP_URL || "";
        return openNew ? navigateNewTab(url) : navigateSameTabExternal(url);
      }

      setIsManagerJwtLoading(true);

      if (openNew) {
        tab.open();
      }

      const response = await jwtRequest();
      const redirectionPath = manageRetUrl || path;

      const url = `${process.env.NEXT_PUBLIC_MANAGER_APP_URL}${
        redirectionPath || ""
      }${path?.includes("?") ? "&" : "?"}jwt=${response.jwt}${
        options?.hash || ""
      }`;

      if (openNew) {
        tab.setLocation(url);
      } else {
        navigateSameTabExternal(url);
      }

      setIsManagerJwtLoading(false);

      return response;
    } catch (e) {
      setIsManagerJwtLoading(false);
      tab.close();
      console.error(e);
    }
  }
  return { navigateToManagerAppByJwt };
};
